import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Every district of one house on a single map; hovering names a district and clicking one selects it.
export default function DistrictHouseMap({ features, houseName, onSelect }) {
    const containerRef = useRef(null);
    const onSelectRef = useRef(onSelect);
    onSelectRef.current = onSelect;

    useEffect(() => {
        if (!containerRef.current || !features.length) return;
        const map = L.map(containerRef.current, { scrollWheelZoom: false, zoomSnap: 0.1 });
        L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 18,
            // The site sends Referrer-Policy: no-referrer (helmet's default), but OpenStreetMap's tile servers require a Referer
            // and block requests without one, so the tiles opt in to sending the origin.
            referrerPolicy: "strict-origin-when-cross-origin",
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        }).addTo(map);
        const base = { color: "#1a2744", weight: 1, fillColor: "#458da1", fillOpacity: 0.2 };
        const layer = L.geoJSON(features, {
            style: base,
            onEachFeature: (feature, item) => {
                const code = feature.properties.district;
                item.bindTooltip(`${houseName} District ${parseInt(code.slice(2), 10)}`, { sticky: true });
                item.on({
                    mouseover: () => item.setStyle({ weight: 2, fillOpacity: 0.45 }),
                    mouseout: () => item.setStyle(base),
                    click: () => onSelectRef.current(code),
                });
            },
        }).addTo(map);
        const fit = () => map.fitBounds(layer.getBounds(), { padding: [16, 16], animate: false });
        fit();
        const observer = new ResizeObserver(() => { map.invalidateSize(); fit(); });
        observer.observe(containerRef.current);
        return () => { observer.disconnect(); map.remove(); };
    }, [features, houseName]);

    return <div className="district-info-map" ref={containerRef} />;
}
